<template>
    <div class="login">
        <el-col :span="12">
            <div style="text-align:center; margin-top:40%;">
                <el-col :span="24">
                    <span style="font-size:30px">Zac的小仓库</span>
                </el-col>
                <el-col :span="24" style="margin-top:3%">
                    <span>GOODS · LIVES · FILES · MEMOS · USERS </span>
                </el-col>
                <el-col :span="24" style="margin-top:3%">
                    <span>zac的小仓库</span>
                </el-col>
            </div>
        </el-col>
        <el-col :span="12">
            <div style="text-align:center; margin-top:35%;">
                <el-card class="box-card" style="margin-left:20%;margin-right:20%">
                    <span>欢迎登录</span>
                    <el-input  placeholder="请输入账号" v-model="user.userName"   style="margin-top:5%"></el-input>
                    <el-input placeholder="请输入密码" v-model="user.password"  show-password style="margin-top:5%"></el-input>
                    <el-button type="primary" round style="margin-top:5%" @click="login">登录</el-button>
                </el-card>
            </div>
        </el-col>
    </div>
</template>

<script>
import Common from './Common'
export default {
  name: 'Login',
  data () {
    return {
      user: {
        userName: '',
        password: ''
      }
    }
  },
  methods: {
    login () {
      this.$axios.post(Common.baseUrl + 'user/login', this.user
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          // this.$message({
          //   message: '保存商品成功！',
          //   type: 'success'
          // })
          localStorage.setItem('Authorization', res.data.data.token)
          console.log(localStorage)
          this.$router.push('/search')
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          localStorage.clear()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue